import { Modal } from 'antd';

type RouterPromptPropsType = {
  title?: string;
  description?: string;
  okText?: string;
  cancelText?: string;
  handleOK?: () => void;
  handleCancel?: () => void;
  isPrompt: boolean;
};

export default function RouterPrompt(props: RouterPromptPropsType) {
  const {
    title = 'Leave this page',
    description = 'It looks like you have been editing something. If you leave before saving, your changes will be lost.',
    okText = 'Confirm',
    cancelText = 'Cancel',
    handleOK,
    handleCancel,
    isPrompt,
  } = props;

  return isPrompt ? (
    <Modal
      title={title}
      open={isPrompt}
      onOk={handleOK}
      okText={okText}
      onCancel={handleCancel}
      cancelText={cancelText}
    >
      {description}
    </Modal>
  ) : null;
}
